import React from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';

import { mapId, mapName } from 'helpers/react_select_helpers';
import { searchProperties } from './api';

import ResearchPropertyOption from './async_select_option';

import 'styles/entity_selector.scss';

export default class ResearchPropertyAsyncSelect extends React.Component {
  static propTypes = {
    researchProperty: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }).isRequired,
    onSelect: PropTypes.func.isRequired
  }

  render() {
    const Option = ResearchPropertyOption;
    return (
      <AsyncSelect
        className={'entity-selector'}
        classNamePrefix=""
        components={{ Option }}
        getOptionLabel={mapName}
        getOptionValue={mapId}
        loadOptions={searchProperties}
        placeholder="Search properties"
        onChange={this.props.onSelect}
      />
    );
  }
}
